export default __webpack_public_path__ + "static/media/deliveries_11.a7e51569.png";